export default __webpack_public_path__ + "bd33ac470832c15f445b7b82c2871a78.svg";